module.exports = __webpack_public_path__ + "img/HAPPY DIWALI.d20a393.svg";